import { UserAvatar } from "@nexus/ui";
import { EMPTY_VALUE } from "./EventIdentityRow";

export function EventActorCell({
  name,
  photoUrl,
}: {
  name: string | null;
  photoUrl?: string | null;
}) {
  if (!name) {
    return <span className="text-muted-foreground">{EMPTY_VALUE}</span>;
  }

  return (
    <span className="flex min-w-0 items-center gap-2">
      <UserAvatar name={name} src={photoUrl} size="sm" className="shrink-0" />
      <span className="truncate">{name}</span>
    </span>
  );
}
